import FilterTitle from './FilterTitle';
export default FilterTitle;